import { render, staticRenderFns } from "./IncidentRiskTypesList.vue?vue&type=template&id=8cb44988"
import script from "./IncidentRiskTypesList.vue?vue&type=script&lang=js"
export * from "./IncidentRiskTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports